import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class LiquidityLadderCriteria extends Model.CriteriaBase {
    static typeName = "LiquidityLadderCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public reportDate: Date | null = DateUtils.monthEnd(DateUtils.today());

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public projectionDate: Date | null = null;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<LiquidityLadderCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Liquidity Ladder Criteria";
    }
}